import { IMPRESSION_ACTIONS, SCREEN_NAME } from "@cart-client/analytics/constants";
import { AnalyticsContextValue } from "@swiggy-private/checkout-core";
import { isEmpty } from "@swiggy-private/js-utils";

interface TimedFreeCashExtraParams {
    uploadId?: string;
    restaurantId?: string;
    cartId?: string;
}

// impression event
export const timedFreeCashCroutonImpressionEvent = (
    message: string,
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    expiryTime?: number,
    extraParams?: TimedFreeCashExtraParams,
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        context: JSON.stringify({ message, ...(!isEmpty(expiryTime) && { expiryTime }) }),
        action: IMPRESSION_ACTIONS.IMPRESSION_CROUTON_TIMED_FREE_CASH,
        extraParams: JSON.stringify(extraParams),
    });
};
